// src/utils/parseReportData.js

/**
 * Transforms the raw QuickBooks response
 * into a flat array suitable for Antd’s Table tree structure.
 */

export function parseProfitAndLossDetailData(data) {
    if (!data?.Rows?.Row) return [];
  
    function traverseRows(rowsArray, level = 0) {
      const result = [];
  
      if (rowsArray) {
        rowsArray.forEach(row => {
          if (row.Header) {
            const name = row.Header.ColData?.[0]?.value ?? 'Unnamed';
            const node = {
              key: `${name}-${level}-${Math.random()}`,
              date: '',
              account: name,
              total: '',
              level,
              isSummary: false,
            };
  
            if (row.Rows?.Row) {
              node.children = traverseRows(row.Rows.Row, level + 1);
            }
  
            if (row.Summary?.ColData?.[0]) {
              const summary = row.Summary.ColData;
              const summaryName = summary[0]?.value ?? '';
              const summaryTotal = summary[6]?.value ?? '';
              node.children = node.children || [];
              node.children.push({
                key: `${summaryName}-summary-${level}-${Math.random()}`,
                date: '',
                account: summaryName,
                total: summaryTotal,
                level: level + 1,
                isSummary: true,
              });
            }
  
            result.push(node);
          }
  
          if (row.type === 'Data' && row.ColData) {
            const col = row.ColData;
            result.push({
              key: `data-${col[0]?.value}-${Math.random()}`,
              date: col[0]?.value ?? '',
              account: `${col[4]?.value || col[3]?.value || 'Transaction'}`,
              total: col[6]?.value ?? '',
              level,
              isSummary: false,
            });
          }
          // Process nested rows if they are not headers
          if (!row.Header && row.Rows?.Row) {
            const children = traverseRows(row.Rows.Row, level + 1);
            result.push(...children);
          }
  
          if (!row.Header && row.Summary?.ColData?.[0]) {
            const summary = row.Summary.ColData;
            const summaryName = summary[0]?.value ?? '';
            const summaryTotal = summary[6]?.value ?? '';
            result.push({
              key: `${summaryName}-summary-${level}-${Math.random()}`,
              account: summaryName,
              total: summaryTotal,
              level,
              isSummary: true,
            });
          }
        });
      }
  
      return result;
    }
  
    return traverseRows(data.Rows.Row);
  }

  export function parseProfitAndLossData(data) {
    if (!data?.Rows?.Row) return [];
  
    const rows = data.Rows.Row;
    const parsedRows = [];
  
    function traverseRows(rowsArray, level = 0) {
      if (!Array.isArray(rowsArray)) return;
  
      rowsArray.forEach(row => {
        if (row.Header) {
          const accountName = row.Header.ColData[0].value;
          parsedRows.push({
            key: `${accountName}-${level}-${Math.random()}`,
            account: accountName,
            total: '',
            level,
            isSummary: false,
          });
        }
  
        if (row.ColData) {
          const accountName = row.ColData[0].value;
          const totalValue = row.ColData[1].value;
          parsedRows.push({
            key: `${accountName}-${level}-${Math.random()}`,
            account: accountName,
            total: totalValue,
            level,
            isSummary: row.type === 'Data',
          });
        }
  
        if (row.Rows) traverseRows(row.Rows.Row, level + 1);
  
        if (row.Summary) {
          const summaryName = row.Summary.ColData[0].value;
          const totalValue = row.Summary.ColData[1].value;
          parsedRows.push({
            key: `${summaryName}-${level}-${Math.random()}`,
            account: summaryName,
            total: totalValue,
            level,
            isSummary: true,
          });
        }
      });
    }
  
    traverseRows(rows);
    return parsedRows;
  }

export function parseCashFlowData(data) {
  if (!data?.Rows?.Row) return [];

  const rows = data.Rows.Row;
  const parsedRows = [];

  function traverseRows(rowsArray, level = 0) {
    if (!Array.isArray(rowsArray)) return;

    rowsArray.forEach(row => {
      if (row.Header) {
        const accountName = row.Header.ColData[0].value;
        parsedRows.push({
          key: `${accountName}-${level}-${Math.random()}`,
          account: accountName,
          total: '',
          level,
          isSummary: false,
        });
      }

      if (row.ColData) {
        const accountName = row.ColData[0].value;
        const totalValue = row.ColData[1].value;
        parsedRows.push({
          key: `${accountName}-${level}-${Math.random()}`,
          account: accountName,
          total: totalValue,
          level,
          isSummary: row.type === 'Data',
        });
      }

      if (row.Rows) traverseRows(row.Rows.Row, level + 1);

      if (row.Summary) {
        const summaryName = row.Summary.ColData[0].value;
        const totalValue = row.Summary.ColData[1].value;
        parsedRows.push({
          key: `${summaryName}-${level}-${Math.random()}`,
          account: summaryName,
          total: totalValue,
          level,
          isSummary: true,
        });
      }
    });
  }

  traverseRows(rows);
  return parsedRows;
}